define([
  'okta/underscore',
  'shared/views/BaseView',
  'shared/util/Time',
  'vendor/plugins/spin'
], function (_, BaseView, Time) {

  var opts = {
    lines: 9, // The number of lines to draw
    length: 0, // The length of each line
    width: 8, // The line thickness
    radius: 12, // The radius of the inner circle
    corners: 1, // Corner roundness (0..1)
    rotate: 23, // The rotation offset
    direction: 1, // 1: clockwise, -1: counterclockwise
    color: '#666', // #rgb or #rrggbb
    speed: 0.8, // Rounds per second
    trail: 50, // Afterglow percentage
    shadow: false, // Whether to render a shadow
    hwaccel: false, // Whether to use hardware acceleration
    className: '', // The CSS class to assign to the spinner
    zIndex: 2e9, // The z-index (defaults to 2000000000)
    top: 'auto', // Top position relative to parent in px
    left: 'auto' // Left position relative to parent in px
  };

  return BaseView.extend({

    constructor: function () {
      if (!this.spinOptions) {
        this.spinOptions = {};
      }
      _.defaults(this.spinOptions, opts);
      BaseView.apply(this, arguments);
    },

    render: function () {
      if (!this.spinAtRender) {
        this.$el.hide();
      }
      BaseView.prototype.render.apply(this, arguments);
      if (this.spinAtRender) {
        this.spin();
      }
      return this;
    },

    spin: function () {
      this.$el.spin(this.spinOptions).show();
      return this;
    },

    empty: function () {
      var $el = this.$el;
      $el.fadeOut(Time.LOADING_FADE, function () {
        $el.spin(false);
      });
    }

  });
});



/** WEBPACK FOOTER **
 ** ./target/js/shared/views/components/BaseSpinner.js
 **/